var map = {
	"./0-portfolio/cursor-hover.svg": 9584,
	"./0-portfolio/cursor-text.svg": 977,
	"./0-portfolio/cursor.svg": 1761,
	"./0-portfolio/moon.svg": 4794,
	"./0-portfolio/noise-texture.svg": 2862,
	"./0-portfolio/placeholder-img.svg": 25,
	"./0-portfolio/sun.svg": 7081,
	"./collaterals/BrianRiot.webp": 7598,
	"./collaterals/DJ.webp": 7232,
	"./collaterals/aktywna-tablica.webp": 8780,
	"./collaterals/amazon-insert1.webp": 619,
	"./collaterals/amazon-insert2.webp": 9229,
	"./collaterals/diamond hotel insert.webp": 7589,
	"./collaterals/finanzexpert.webp": 1284,
	"./collaterals/m3lomoore flyer.webp": 6700,
	"./collaterals/sweet-stuff-flyer.webp": 7538,
	"./collaterals/symphony-insert.webp": 7800,
	"./collaterals/uverit-flyer.webp": 3760,
	"./collaterals/veronica-b-vannucchi.webp": 7615,
	"./color-palettes/13-month-calendar.webp": 446,
	"./color-palettes/Amazeam.webp": 2326,
	"./color-palettes/Atombits.webp": 2523,
	"./color-palettes/Cozy Fluff.webp": 7779,
	"./color-palettes/Hier im Ort.webp": 4649,
	"./color-palettes/Jangflix Color Palette.webp": 202,
	"./color-palettes/JoVenture.webp": 1371,
	"./color-palettes/My Ally.webp": 6799,
	"./color-palettes/Nursify Color Palette.webp": 5944,
	"./color-palettes/Sincerely OMara.webp": 9823,
	"./color-palettes/THAI GATE.webp": 5285,
	"./color-palettes/TallSoftBoi.webp": 7825,
	"./color-palettes/Uverit Color Palette.webp": 7103,
	"./color-palettes/akashic-resonance.webp": 7348,
	"./color-palettes/b-med.webp": 3984,
	"./color-palettes/chanan.webp": 8729,
	"./color-palettes/fireflyloop.webp": 3614,
	"./color-palettes/gabriella-v1.webp": 492,
	"./color-palettes/gabriella-v2.webp": 4494,
	"./color-palettes/i-am-remote.webp": 3929,
	"./color-palettes/kew-central.webp": 7738,
	"./color-palettes/key-places.webp": 1922,
	"./color-palettes/lumifilms.webp": 4615,
	"./color-palettes/mr-seo-tech.webp": 6811,
	"./color-palettes/sayiastar.webp": 4945,
	"./color-palettes/sistair.webp": 724,
	"./color-palettes/wanda-cox.webp": 2261,
	"./dev-projects/color-palette-desktop.webp": 708,
	"./dev-projects/color-palette-mobile.webp": 2728,
	"./dev-projects/converter-desktop.webp": 9664,
	"./dev-projects/converter-mobile.webp": 8196,
	"./dev-projects/cookbook-desktop.webp": 9966,
	"./dev-projects/cookbook-mobile.webp": 2880,
	"./dev-projects/keep-it-fit-desktop.webp": 1868,
	"./dev-projects/keep-it-fit-logo.svg": 7949,
	"./dev-projects/keep-it-fit-mobile.webp": 8722,
	"./dev-projects/logo-test-desktop.webp": 6203,
	"./dev-projects/logo-test-mobile.webp": 4183,
	"./dev-projects/rapid-core-desktop.webp": 7273,
	"./dev-projects/rapid-core-logo.svg": 1626,
	"./dev-projects/rapid-core-mobile.webp": 8516,
	"./dev-projects/skillpeak-desktop.webp": 1995,
	"./dev-projects/skillpeak-mobile.webp": 7271,
	"./dev-projects/uverit-logo.svg": 1051,
	"./icons/404-avocado-icon.svg": 6289,
	"./icons/404-clock-icon.svg": 4444,
	"./icons/angle.svg": 3457,
	"./icons/archaic.svg": 3215,
	"./icons/area.svg": 2922,
	"./icons/astronomical.svg": 5715,
	"./icons/baked-goods-icon.svg": 1055,
	"./icons/battery-icon.svg": 4117,
	"./icons/bookmark-icon.svg": 6389,
	"./icons/briefcase.svg": 2592,
	"./icons/brush-icon.svg": 849,
	"./icons/calculator-icon.svg": 5434,
	"./icons/calendar.svg": 4872,
	"./icons/camera-icon.svg": 2769,
	"./icons/chat-icon.svg": 6281,
	"./icons/checkmark new.svg": 8819,
	"./icons/checkmark-icon.svg": 6983,
	"./icons/clock-icon.svg": 9136,
	"./icons/clock.svg": 1363,
	"./icons/color-palette-icon.svg": 9430,
	"./icons/common.svg": 8936,
	"./icons/contact-icon.svg": 87,
	"./icons/copy-icon.svg": 3937,
	"./icons/course-icon.svg": 9365,
	"./icons/crosshair.svg": 4191,
	"./icons/data_storage.svg": 7560,
	"./icons/delete-icon.svg": 2433,
	"./icons/density.svg": 2739,
	"./icons/dessert-icon.svg": 3495,
	"./icons/dev-hero-icon.svg": 8687,
	"./icons/dice-icon.svg": 1150,
	"./icons/dish-icon.svg": 4893,
	"./icons/do-icon.svg": 1026,
	"./icons/dont-icon.svg": 9988,
	"./icons/drink-icon.svg": 8127,
	"./icons/emoji-icon.svg": 1824,
	"./icons/energy.svg": 5277,
	"./icons/fav-list-icon.svg": 5965,
	"./icons/flyer-icon.svg": 7620,
	"./icons/force.svg": 8952,
	"./icons/frequency.svg": 4112,
	"./icons/fruits-vegetables-icon.svg": 6923,
	"./icons/graduation-hat-icon.svg": 7253,
	"./icons/grains-icon.svg": 2251,
	"./icons/light-bulb.svg": 9931,
	"./icons/link new.svg": 2194,
	"./icons/list-icon.svg": 7502,
	"./icons/list-icon2.svg": 4318,
	"./icons/magnifying-glass-icon.svg": 1823,
	"./icons/mail-icon.svg": 4470,
	"./icons/main-icon.svg": 4541,
	"./icons/marine.svg": 9006,
	"./icons/mass.svg": 3342,
	"./icons/meat-dairy-icon.svg": 1765,
	"./icons/microscopic.svg": 2404,
	"./icons/mod_calendar.svg": 7864,
	"./icons/multi-page-pdf-icon.svg": 151,
	"./icons/mute-icon.svg": 8751,
	"./icons/note-icon.svg": 6124,
	"./icons/numeral_systems.svg": 7548,
	"./icons/other-icon.svg": 499,
	"./icons/pastry-bag-icon.svg": 2737,
	"./icons/pdf-btn.svg": 444,
	"./icons/phone-icon.svg": 1248,
	"./icons/pin-icon.svg": 1135,
	"./icons/pin-icon2.svg": 9955,
	"./icons/pixel-art-icon.svg": 6898,
	"./icons/placeholder-icon.svg": 8162,
	"./icons/portion-number-icon.svg": 5609,
	"./icons/power.svg": 8205,
	"./icons/pressure.svg": 6312,
	"./icons/product-icon.svg": 9615,
	"./icons/quantity.svg": 3951,
	"./icons/ready-meal-icon.svg": 745,
	"./icons/recipe-icon.svg": 7764,
	"./icons/references-icon.svg": 4892,
	"./icons/score-icon.svg": 133,
	"./icons/semi-finished-products-icon.svg": 7046,
	"./icons/seo-icon.svg": 1087,
	"./icons/settings-icon.svg": 2482,
	"./icons/snack-icon.svg": 6054,
	"./icons/speed.svg": 271,
	"./icons/spice-icon.svg": 4199,
	"./icons/star.svg": 5548,
	"./icons/stats-icon.svg": 6158,
	"./icons/sweets-snacks-icon.svg": 1154,
	"./icons/switch-icon.svg": 2747,
	"./icons/temperature.svg": 9389,
	"./icons/time-active-new.svg": 3878,
	"./icons/time-icon.svg": 8748,
	"./icons/time-passive-new.svg": 7237,
	"./icons/time-total-new.svg": 6868,
	"./icons/time.svg": 3763,
	"./icons/turn-page-icon.svg": 8817,
	"./icons/upload-icon.svg": 6087,
	"./icons/user-icon.svg": 9465,
	"./icons/vegan-icon.svg": 5523,
	"./icons/volume.svg": 3779,
	"./icons/web-design-icon.svg": 8085,
	"./icons/website-icon.svg": 774,
	"./icons/weight-icon.svg": 4201,
	"./logos/Atombits.svg": 758,
	"./logos/Cozy Fluff Logo.svg": 6537,
	"./logos/Keep It Fit logo full.svg": 8446,
	"./logos/Luigi's Mansion logo excluded reverse.webp": 7747,
	"./logos/My Ally.svg": 1213,
	"./logos/New Horizon Full white.svg": 1974,
	"./logos/Superior Star Logo excluded reverse v2.webp": 8490,
	"./logos/baby born.svg": 493,
	"./logos/diamond hotel white.svg": 7300,
	"./logos/dream team.svg": 1759,
	"./logos/fox logo white.svg": 6440,
	"./logos/happy vet white.svg": 5010,
	"./logos/jangflix.svg": 9110,
	"./logos/logo-wb.svg": 6827,
	"./logos/rapid-core-logo.svg": 5243,
	"./logos/royal-casino.svg": 1692,
	"./logos/sweet-stuff.svg": 5206,
	"./logos/symphony.svg": 6936,
	"./logos/timeless.svg": 5551,
	"./logos/uverit-mn-logo-.svg": 7591,
	"./logos/uverit-w.svg": 1860,
	"./pixel-art/alien.webp": 1001,
	"./pixel-art/apple-golden.webp": 5531,
	"./pixel-art/apple.webp": 4237,
	"./pixel-art/average-guy.webp": 3853,
	"./pixel-art/axe.webp": 621,
	"./pixel-art/beef-cooked.webp": 5223,
	"./pixel-art/beef.webp": 2226,
	"./pixel-art/bomb.webp": 4665,
	"./pixel-art/bone.webp": 4485,
	"./pixel-art/bread.webp": 1680,
	"./pixel-art/carrot.webp": 3909,
	"./pixel-art/coin.webp": 4463,
	"./pixel-art/cookie.webp": 5714,
	"./pixel-art/egg.webp": 8655,
	"./pixel-art/fish1.webp": 4084,
	"./pixel-art/fish2.webp": 4807,
	"./pixel-art/fish3.webp": 1057,
	"./pixel-art/gold ingot.webp": 9253,
	"./pixel-art/golden boots.webp": 1383,
	"./pixel-art/golden chestplate.webp": 3163,
	"./pixel-art/golden helmet.webp": 5384,
	"./pixel-art/golden trousers.webp": 2188,
	"./pixel-art/hoe.webp": 3734,
	"./pixel-art/ice-cream.webp": 8925,
	"./pixel-art/iron boots.webp": 5441,
	"./pixel-art/iron chestplate.webp": 7443,
	"./pixel-art/iron helmet.webp": 2606,
	"./pixel-art/iron ingot.webp": 2081,
	"./pixel-art/iron trousers.webp": 4730,
	"./pixel-art/mushroom.webp": 6592,
	"./pixel-art/pickaxe.webp": 2395,
	"./pixel-art/pie.webp": 72,
	"./pixel-art/rabbit.webp": 2071,
	"./pixel-art/shovel.webp": 8666,
	"./pixel-art/sword.webp": 1501,
	"./pixel-art/toadstool.webp": 7841,
	"./pixel-art/watermelon.webp": 3944,
	"./web-design/Atombits.webp": 5628,
	"./web-design/Cozy Fluff.webp": 2534,
	"./web-design/Keep-If-Fit.webp": 7871,
	"./web-design/My Ally.webp": 8640,
	"./web-design/Paw Guardians.webp": 3960,
	"./web-design/Portfolio.webp": 2723,
	"./web-design/VibeSync.webp": 8179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;